<script setup lang="ts">
/**
 * Réglage oui/non du volet Paramètres : titre, explication et interrupteur.
 * Toute la ligne bascule le réglage (cible tactile), pas seulement
 * l'interrupteur.
 */
defineProps<{
  title: string;
  description: string;
  /** Message d'avertissement sous l'explication (ex. réglage risqué). */
  warning?: string;
}>();

const enabled = defineModel<boolean>({ required: true });
</script>

<template>
  <div
    class="rounded option-btn w-100 d-flex align-items-center gap-2"
    role="switch"
    :aria-checked="enabled"
    :aria-label="title"
    tabindex="0"
    @click="enabled = !enabled"
    @keydown.enter.prevent="enabled = !enabled"
    @keydown.space.prevent="enabled = !enabled"
  >
    <div class="col d-flex flex-column text-start">
      <div class="text-truncate text-white">{{ title }}</div>
      <div class="text-grey" style="line-height: 15px !important">
        <small>{{ description }}</small>
      </div>
      <small v-if="warning" class="toggle-warning">{{ warning }}</small>
    </div>
    <!-- La ligne entière bascule : l'interrupteur n'est qu'un témoin. -->
    <el-switch
      :model-value="enabled"
      class="settings-switch"
      tabindex="-1"
      aria-hidden="true"
    />
  </div>
</template>

<style lang="scss" scoped>
.settings-switch {
  --el-switch-on-color: var(--canvas-btn-active-bg);
  --el-switch-off-color: rgba(255, 255, 255, 0.18);
  flex-shrink: 0;
  pointer-events: none;
}

.toggle-warning {
  margin-top: 4px;
  color: var(--bs-warning);
  line-height: 15px;
}
</style>
